module.exports = __webpack_public_path__ + "img/h-4.d8f193e7.png";